// extracted by mini-css-extract-plugin
export var customGrid = "featured-blocks-module--customGrid--10a97";
export var heading = "featured-blocks-module--heading--1adc9";
export var image = "featured-blocks-module--image--8ac3f";
export var root = "featured-blocks-module--root--eb30e";
export var switchOrder = "featured-blocks-module--switchOrder--0dea7";
export var text = "featured-blocks-module--text--78d6a";